import * as React from 'react';

interface IDemoSalesContactIDemoSalesContact {
    firstName: string;
    lastName: string;
    email: string;
    meetingLink: string;
}

interface IDemoAccessSalesProps {

}

interface IDemoAccessSalesState {
    loaded: boolean;
    sender?: IDemoSalesContactIDemoSalesContact;
}

export default class DemoAccessSales extends React.PureComponent<IDemoAccessSalesProps, IDemoAccessSalesState> {
    constructor(props: IDemoAccessSalesProps) {
        super(props);
        this.state = { loaded: false };
    }

    async componentWillMount() {
        const response = await fetch(`/api/demolink/demosalescontact${window.location.search}`);
        const data = await response.json() as IDemoSalesContactIDemoSalesContact;
        this.setState({ loaded: true, sender: data })
    }

    render() {
        let showGenericSender = this.state.sender == null || ((this.state.sender.firstName || "") + (this.state.sender.lastName || "") + (this.state.sender.email || "") == "");

        return <div style={{ "position": "fixed", "width": "100%", "left": "0", "top": "0", "height": "40px", "fontSize": "18px", "borderTop": "1px solid #dfdfe1;" }} >
            {this.state.loaded && <>
                {showGenericSender && <span style={{ "display": "inlineBlock", "paddingTop": "8px", "paddingLeft": "10px" }}>
                    <span style={{ "color": "#fdb813", "fontWeight": "bold" }}>Contact Sales</span>
                    <span style={{ "marginLeft": "30px", "marginRight": "30px" }}>Email: <a href='mailto:sales@testout.com' style={{ "color": "#56b8b4" }}>sales@testout.com</a></span>
                    <span>Call: 800-877-4889</span>
                </span>}
                {!showGenericSender && <>
                    <span style={{ "background": "#fdb813", "display": "inline-block", "height": "40px", "paddingTop": "8px", "paddingLeft": "10px", "paddingRight": "15px" }}>Sales Contact: {this.state.sender?.firstName} {this.state.sender?.lastName}</span>
                    {this.state.sender?.meetingLink != null && <span style={{ "paddingTop": "8px", "marginLeft": "30px" }}><a href={this.state.sender?.meetingLink} target='_blank' style={{ "color": "#56b8b4" }}>Schedule a meeting with {this.state.sender?.firstName}</a></span>}
                    <span style={{ "marginLeft": "30px", "paddingTop": "8px" }}>Email: <a href={"mailto:" + this.state.sender?.email} style={{ "color": "#56b8b4" }}>{this.state.sender?.email}</a></span>
                </>}
            </>}
        </div>;
    }
}